import PropTypes          from 'prop-types';
import { useTranslation } from 'next-i18next';
import Link               from 'next/link';
import SiteView           from 'components/Site/View';
import UIList             from 'components/UI/List';
import ArticleItem        from 'components/Article/Item';
import isEmpty            from 'lodash/isEmpty';
import { format }         from 'date-fns';
import styles             from './article-full.module.scss';
import CalendarIcon       from '@material-ui/icons/EventOutlined';
import CategoryIcon       from '@material-ui/icons/AccountTreeOutlined';

function ArticleFullView ({ article, moreArticles }) {
  const { t } = useTranslation('common');

  const getArticleDate = () => {
    const { publishedAt, createdAt } = article;

    return format(new Date(publishedAt || createdAt), 'dd.MM.yyyy');
  };

  return (
    <div className={styles.root}>
      <SiteView title={article.title}>
        <div className={styles.params}>
          <div className={styles.param}>
            <CalendarIcon/> {getArticleDate()}
          </div>
          <div className={styles.param}>
            <CategoryIcon/>
            <Link href={`/articles?category=${article.articleCategory.slug}`}>
              <a>{article.articleCategory.name}</a>
            </Link>
          </div>
        </div>
        
        <div className={styles.content}>
          <If condition={!isEmpty(article.photos)}>
            <img src={article.photos[0].file.url} alt=""/>
          </If>
          <pre dangerouslySetInnerHTML={{__html: article.content}}/>
        </div>
        
        <div className={styles.tags}>
          <For each="tag" of={article.tags} index="index">
            <If condition={!isEmpty(tag)}>
              <div className={styles.tag} key={index}>
                {tag}
              </div>
            </If>
          </For>
        </div>
      </SiteView>

      <div className={styles.also}>
        <div className={styles.also_title}>
          {t('common.articles.readAlso')}
        </div>
        <div className={styles.also_articles}>
          <UIList
            data={moreArticles}
            itemComponent={ArticleItem}
            itemComponentProps={{ showCategory: false }}
          />
        </div>
      </div>
    </div>
  )
};

ArticleFullView.propTypes = {
  article:      PropTypes.object.isRequired,
  moreArticles: PropTypes.array
};

export default ArticleFullView;